import { Action, createReducer, on } from '@ngrx/store';
import { fromProductGoalsAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productGoalsFeatureKey = 'productGoals';

export interface ProductGoalsState {
  productGoalsResponse: IStaticDataResponse[];
  productGoalsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductGoalsState = {
  productGoalsFailure: undefined,
  productGoalsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductGoalsAction.loadProductGoals, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductGoalsAction.loadProductGoalsSuccess, (state, action) => ({
    ...state,
    productGoalsResponse: action.response
  })),

  on(fromProductGoalsAction.loadProductGoalsFailure, (state, action) => ({
    ...state,
    productGoalsFailure: action.error
  }))
);

export const getProductGoalsResponse = (state: ProductGoalsState) => state.productGoalsResponse;
export const getProductGoalsFailure = (state: ProductGoalsState) => state.productGoalsFailure;
export const getProductGoalsIsLoaded = (state: ProductGoalsState) => state.loaded;
